import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaCardDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-rt-vertx',
	templateUrl:'./VertxEventBusPage.html',
	styles: [],
	styleUrls:['./VertxEventBusPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
		WaCardDirective,
],
	standalone:true
})
export class VertxEventBusPage
{
	mdContent_1186 = `When you need server-to-browser push, the Angular plugin includes a built-in STOMP server at \`/eventbus\` backed by the Vert.x event bus. No external broker required. The generated \`EventBusService\` manages connections, reconnection, and message routing. Plugins like AG Grid, FullCalendar, and Chart.js already use this for live data push.`;
}
